<app-alert alertType="{{type}}">
    <div class="error-line" *ngFor="let error of errorStateMatcher.errors">
        {{ error.description ? error.description : error.code }}
    </div>
</app-alert>
